export default __webpack_public_path__ + "static/media/gallery-wip-grenade_05.26861909.jpg";